import { render, staticRenderFns } from "./chat.vue?vue&type=template&id=96abbff0&scoped=true"
import script from "./chat.vue?vue&type=script&lang=js"
export * from "./chat.vue?vue&type=script&lang=js"
import style0 from "./chat.vue?vue&type=style&index=0&id=96abbff0&prod&lang=css"
import style1 from "./chat.vue?vue&type=style&index=1&id=96abbff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96abbff0",
  null
  
)

export default component.exports